<section class="header">
    <edge-global-header></edge-global-header>
  </section>
  
  <section class="support-header">
    <edge-support-header></edge-support-header>
  </section>
  
  <section class="social">
    <a angulartics2On="click" angularticsCategory="Outbound Clicks" angularticsEvent="Social" [angularticsProperties]="{ label: 'GoArmy Twitter' }"
      href="https://twitter.com/goarmyedge" target="_blank">
      <img src="/assets/images/social/logo-white.png" alt="" class="Twitter">
    </a>
    <a angulartics2On="click" angularticsCategory="Outbound Clicks" angularticsEvent="Social" [angularticsProperties]="{ label: 'GoArmy Youtube' }"
      href="https://www.youtube.com/goarmyedge" target="_blank">
      <img src="/assets/images/social/youtube.svg" alt="">
    </a>
    <a angulartics2On="click" angularticsCategory="Outbound Clicks" angularticsEvent="Social" [angularticsProperties]="{ label: 'GoArmy Facebook' }"
      href="https://www.facebook.com/GoArmyEdgeFootball/" target="_blank">
      <img src="/assets/images/social/facebook.svg" alt="">
    </a>
  </section>
  
  <section class="content">
    <h1>GoArmy Edge Fitness Support</h1>

    <div class="featured">
      <p>Looking for some help using the app? Follow these steps for success.</p>
  
      <div class="feature-wrap">
        <div class="feature">
          <a (click)="showModal('Sv2zDNpomQQ')">
            <img class="easel" src="/assets/images/support/vid-easel.svg" alt="">
            <i class="material-icons">play_arrow</i>
          </a>
          <h3>Watch Getting Started Video</h3>
          <p>This video shows the capabilites of GoArmy Edge Fitness and will give you an overview of the interface and
            features.</p>
        </div>
  
        <div class="feature">
          <a href="//assets.goarmyedge.com/Edge/goarmy-edge-soccer-manual.pdf">
            <img class="manual" src="/assets/images/support/manual.svg" alt="">
            <i class="material-icons">get_app</i>
          </a>
          <h3>Download Manual</h3>
          <p>Download and print a copy of the manual so that you can reference it quickly. Reading the entire manual will
            help you understand the features and structure of the app.</p>
        </div>
      </div>
    </div>
  </section>
  
  <section class="footer">
    <edge-global-footer></edge-global-footer>
  </section>